import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './breadcrumbs.component.scss';
var Breadcrumbs = /** @class */ (function (_super) {
    tslib_1.__extends(Breadcrumbs, _super);
    function Breadcrumbs(element) {
        return _super.call(this, element) || this;
    }
    Breadcrumbs.prototype.init = function () { };
    Breadcrumbs.prototype.bindEvents = function () { };
    return Breadcrumbs;
}(Base));
export { Breadcrumbs };



//////////////////
// WEBPACK FOOTER
// ./components/breadcrumbs/breadcrumbs.component.ts
// module id = 154
// module chunks = 0